import eventType from "../eventType";

const pushDataLayer = data => {
	if (window.dataLayer) {
		window.dataLayer.push(data);
	}
};

const STEPS = {
	"oferta-de-milhas": "oferta-milhas",
	"login-programa-de-fidelidade": "dados-programa",
	"cartao-de-credito": "dados-cartao",
	"conclusao-oferta": "conclusao-oferta",
	"edicao-oferta-de-milhas": "edicao-oferta",
	"edicao-cartao-de-credito": "edicao-dados-cartao",
	"edicao-conclusao-oferta": "edicao-oferta"
};

const STEPS_MOBILE = {
	"quantidade":"oferta-milhas-mobile",
	"valor":"oferta-valor-mobile",
	"login":"dados-usuario-mobile",
	"senha":"dados-senha-mobile",
	"banco":"dados-banco-mobile",
	"agencia":"dados-banco-agencia-mobile",
	"conta":"dados-banco-conta-mobile",
	"numero":"dados-cartao-numero-mobile",
	"validade":"dados-cartao-validade-mobile",
	"cvv":"dados-cartao-cvv-mobile",
	"nome":"dados-cartao-nome-mobile",
	"conclusao-oferta": "conclusao-oferta",
	"telefone":"dados-telefone",
}

const transformObjectSelectOffer = data => {
	const {
		quantityMiles,
		priceMiles,
		international,
		step,
		bank,
		isMobile,
		paymentDeadline,
		averageMiles,
		twoFactorAuthenticationStrategy
	} = data;
	const eventData = {
		product: "Ofertantes",
		bid_miles: quantityMiles,
		price_miles: priceMiles ? parseFloat(priceMiles.replace(",", ".")) : 0,
		product_type: parseInt(international, 2) ? "internacional" : "nacional",
		payment_deadline: paymentDeadline,
		average_miles: averageMiles,
		two_factor_strategy: twoFactorAuthenticationStrategy
	};
	const hasBank = bank !== undefined;
	const isLoginToFidelityProgramStep = step === "login-programa-de-fidelidade";
	const isMobileBankStep = isMobile && step === "banco";

	if (hasBank && (isLoginToFidelityProgramStep || isMobileBankStep)) {
		eventData.bank = bank;
	}

	return eventData;
};

const getFactorQuantityMilesChanged = (oldQntMiles, actualQntMiles) => {
	if (oldQntMiles < actualQntMiles) return "aumentou";
	if (oldQntMiles > actualQntMiles) return "dimuinuiu";
	return "sem alteração";
};

const transformObjectSelectOfferEdit = data => {
	const {
		oldQuantMiles,
		actualQuantMiles,
		priceMiles,
		international,
		paymentDeadline,
		averageMiles,
		twoFactorAuthenticationStrategy
	} = data;

	return {
		product: "Ofertantes",
		edt_miles: getFactorQuantityMilesChanged(oldQuantMiles, actualQuantMiles),
		bid_miles: actualQuantMiles,
		price_miles: priceMiles ? parseFloat(priceMiles.replace(",", ".")) : 0,
		product_type: parseInt(international, 2) ? "internacional" : "nacional",
		payment_deadline: paymentDeadline,
		average_miles: averageMiles,
		two_factor_strategy: twoFactorAuthenticationStrategy
	};
};

const mountSelectContentOffer = offer => {
	const eventData = transformObjectSelectOffer({ ...offer, isMobile: false });
	pushDataLayer({
		event: "select-content-ofertante",
		content_type: STEPS[offer?.step?.toLowerCase()],
		item_id: offer?.fidelityName,
		productData: [eventData]
	});
};

const mountSelectEditContentOffer = offer => {
	const eventData = transformObjectSelectOfferEdit(offer);
	pushDataLayer({
		event: "select-content-ofertante",
		content_type: STEPS[offer?.step?.toLowerCase()],
		item_id: offer?.fidelityName,
		productData: [eventData]
	});
};

const mountSelectContentMobileOffer = offer => {
	const eventData = transformObjectSelectOffer({ ...offer, isMobile: true });
	pushDataLayer({
		event: "select-content-ofertante",
		content_type: STEPS_MOBILE[offer?.step?.toLowerCase()],
		item_id: offer?.fidelityName,
		productData: [eventData]
	});
};

const GA = {
	pushDataLayer,
	mountSelectContentOffer,
	mountSelectEditContentOffer,
	mountSelectContentMobileOffer
};

export default GA;
